import React from 'react';
import { NavLink } from 'react-router-dom';

export const LoggedOutProfileMenu = ({ t, showLogin }) => (
  <button
    onClick={showLogin}
    className="mnd-navigation-menu__item-hitarea mnd-button--link"
  >
    <i className="fas fa-key" />
    {t('global_navigation-link_authenticate')}
  </button>
);

export const LoggedOutHeaderMenu = ({ t, site, createNewsroomLink }) => {
  return (
    <div className="mnd-navigation__header">
      <ul className="mnd-navigation-menu">
        <li className="mnd-navigation-menu__item">
          <NavLink
            to={{
              pathname: '/',
            }}
            isActive={(match, location) =>
              location.pathname === '/' ||
              location.pathname === '/stories' ||
              location.pathname === '/organisations'
            }
            activeClassName="mnd-navigation-menu__item-hitarea--active"
            className="mnd-navigation-menu__item-hitarea mnd-button--link"
          >
            {t('common_navigation-menu_title-stories')}
          </NavLink>
        </li>
        <li className="mnd-navigation-menu__item">
          <a
            href={createNewsroomLink}
            className="mnd-navigation-menu__item-hitarea mnd-button--link"
          >
            {t('common_navigation-menu_title-product')}
          </a>
        </li>
      </ul>
    </div>
  );
};
